'use client';

import { useState, useTransition } from 'react';
import  './LoginForm.css'; // Using CSS Modules
import { Link } from 'react-router-dom';
import { useRegisterMutation } from '../api/authApi';

export default function RegisterForm({ setView }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: ''
  });

  const [error, setError] = useState('');
  const [isPending, startTransition] = useTransition();
  const [registerApi] = useRegisterMutation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({  
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validation
    if (!formData.email || !formData.password) {
      setError('Please fill in all fields');
      return;
    }

    startTransition(async () => {
      try {

        const registerResponse = await registerApi(formData).unwrap();
        console.log(registerResponse);

        if (registerResponse.success) {
          setView('login');
        }
        
      } catch (err) {
        setError(err.data?.message || err?.message || 'Invalid email or password');
      }
    });
  };

  return (
    <div className="container">
      <div className="card">
        <h1 className="title"> Create account</h1>
        {error && (
          <p className="error">
            {error}
          </p>
        )}

        <form onSubmit={handleSubmit} className="form">
          <div className="formGroup">
            <label htmlFor="name" className="label">
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="input"
              placeholder="Enter your name"
            />
          </div>

          <div className="formGroup">
            <label htmlFor="email" className="label">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="input"
              placeholder="abc@example.com"
            />
          </div>

          <div className="formGroup">
            <label htmlFor="password" className="label">
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="input"
              placeholder="••••••••"
              minLength="5"
            />
          </div>

          <button
            type="submit"
            className="button"
            disabled={isPending}
          >
            {isPending ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <div className="footer">
        <p>
          Already have an account? <Link onClick={() => setView('login')} className="link">Sign In</Link>
        </p>
        </div>
      </div>
    </div>
  );
}